import { useDispatch } from 'react-redux';
import { ListItem } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { selectSortOrder } from '@common/SortBy/actions/sortByActions';
import {
    GA_FILTERS_SORTING_CATEGORY,
    GA_FILTER_SORTING_ACTION
} from '@common/Tracking';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';

function SortingListItem({
    value,
    label,
    selected,
    closeSlidePanel
}) {
    const dispatch = useDispatch();
    const sortId = value === '-1' ? 'popular' : value;

    const handleClick = () => {
        pushGAEventToDataLayer(GA_FILTERS_SORTING_CATEGORY, GA_FILTER_SORTING_ACTION, sortId);
        dispatch(selectSortOrder(value));
        closeSlidePanel();
    };

    return (
        <ListItem
            key={value}
            isActive={selected}
            {...!selected && {
                onClick: handleClick
            }}
        >
            <Toggle
                id={sortId}
                isChecked={selected}
                label={label}
                variant="radio"
            />
        </ListItem>
    );
}

export default SortingListItem;
